export default {
  title: 'Studio (V2)',
  description: 'Créez et gérez le site web du restaurant avec le nouveau Website Studio.',
  retry: 'Réessayer',
  deleted: 'Projet supprimé.',
  errors: {
    load: "Le projet Studio (V2) n'a pas pu être chargé.",
    create: "Le projet n'a pas pu être créé. Veuillez réessayer.",
    delete: "Le projet n'a pas pu être supprimé. Veuillez réessayer.",
  },
  EmptyState: {
    title: "Aucun projet Studio (V2) pour l'instant",
    description:
      'Créez un projet pour construire le site web dans le nouveau Website Studio. Studio (V1) reste inchangé.',
    description_no_access: "Un responsable d'intégration peut créer le projet pour cette marque.",
    create: 'Créer un projet',
  },
  ProjectCard: {
    unnamed: 'Projet sans nom',
    edit: 'Modifier dans Studio',
    delete: 'Supprimer',
    open: 'Ouvrir',
    no_domain: 'Pas encore de domaine',
    fields: {
      uuid: 'UUID',
      domain: 'Domaine',
      websites: 'Sites web',
    },
    delete_confirm: {
      title: 'Supprimer ce projet ?',
      description: 'Cela supprime le projet Studio (V2) et ses sites web. Vous pourrez en créer un nouveau plus tard.',
      ok: 'Supprimer',
      cancel: 'Annuler',
    },
  },
};
